import type { Article as GQLArticle } from "~/api/prismic/graphql/queries"
import type { Article } from "~/api/prismic/types"
import { getRichTextBlocks } from "~/utils/prismic/assertJsonTypes"
import * as RichText from "~/utils/prismic/richText"

import { getFirstParagraph } from "./getFirstParagraph"

export const getSummaryText = (article: Article): string => {
  return (
    article.data.meta_description ||
    RichText.asText(article.data.subtitle) ||
    getFirstParagraph(article) ||
    ""
  )
}

export const getSummaryFromGQLArticle = (
  article: Pick<GQLArticle, "meta_description" | "subtitle">,
): string => {
  const subtitle = getRichTextBlocks(article.subtitle)

  return article.meta_description || RichText.asText(subtitle) || ""
}
